module.exports = __webpack_public_path__ + "assets/images/taca.502d9091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taca.png
// module id = 805
// module chunks = 1